import { IAdesaoListResponse } from "../Adesoes.types";
import { useState, useEffect } from "react";
import api from "services/api";

import { useMutation } from "@tanstack/react-query";
import { useParams } from "react-router-dom";


function useListAdesao() {
    const { organizationId, contractId } = useParams() as { organizationId: string, contractId: string };
    const [data, setData] = useState<IAdesaoListResponse | null>(null);
    
    /**
     * Unfortunely we can't rely on passing only the buyer ID to the backend. Instead, in order to make it
     * work, we need to pass the current organizationId to the backend and handle if it's a buyer or
     * seller in the server side.
     */
    const { data: originalData, isPending, isError, mutate } = useMutation({
        mutationFn: async () => {
            const { data } = await api.get<{ data: IAdesaoListResponse }>(`/apps/adesao/${organizationId}/${contractId}`);
            
            return data.data;
        },
        onSuccess: (data) => {
            setData(data);
        },

    });

    function handleChangePlan(personId: string, planId: string) {
        if (!data?.data) return;
        
        const copy = [...data.data];
        const wasModified = !(originalData?.data.find(originalPerson => originalPerson.id === personId && originalPerson.chosenPlan === planId)) ? true : false
        const copyChanged = copy.map(person => person.id !== personId ? person : ({
            ...person,
            wasModified,
            chosenPlan: planId,
        }));
        
        setData((prev) => ({ metadata: prev?.metadata, data: [...copyChanged] }));
    };

    function handleChangeDate(personId: string, newDate: string) {
        if (!data?.data) return;

        const copy = [...data.data];
        // const copyChanged = copy.map(person => {
        //     if (person.id !== personId) return person;

        //     const a = {
        //         ...person,
        //         selectedDate: newDate,
        //     }
        //     console.log("!!!!!", a);
        //     return a;
        // });
        const copyChanged = copy.map(person => person.id !== personId ? person : ({
            ...person,
            selectedDate: newDate,
        }));

        setData((prev) => ({ metadata: prev?.metadata, data: [...copyChanged] }));
    }

    function handleCancelPlan() {
        if (originalData) setData(originalData);
    }

    useEffect(() => {
        mutate();
    }, []);

    return { data, isPending, isError, handleChangeDate, handleChangePlan, handleCancelPlan };
}

export { useListAdesao };
